import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { ExtendedLendingTransaction, ExtendedLendingTransactionListResponse, ExtendedLendingTransactionQueryParams } from '@frontend/transaction/types';

export class TransactionLendingClient extends APIClient {
    public static readonly endpoint = '/transaction-api/ext/v1';

    public static async fetchLendingTransactions(
        queryParams?: ApiQueryParams<ExtendedLendingTransactionQueryParams | string>
    ): Promise<ExtendedLendingTransactionListResponse> {
        return this.apiPaginated<ExtendedLendingTransactionListResponse, ExtendedLendingTransactionQueryParams | string>(
            `${this.endpoint}/lending-transactions`,
            queryParams
        );
    }

    public static async fetchLendingTransaction(accountId: string, transactionId: string): Promise<ExtendedLendingTransaction> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/lending-transactions/${transactionId}`);
        return await this.handleResponse<ExtendedLendingTransaction>(response);
    }
}
